import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { useId } from 'utils/hooks';

/**
 * @param {import('react').InputHTMLAttributes<HTMLInputElement> & {
 *  inputRef?: React.Ref<HTMLInputElement>
 *  size?: import('utils/types').Size
 *  label?: string
 *  caption?: string
 *  tooltipText?: string
 *  value?: string
 *  onChange?: (value: string, event: React.ChangeEvent<HTMLInputElement>) => void
 *  error?: string
 *  disabled?: boolean
 *  bypassReadMode?: boolean
 *  className?: string
 *  inputWrapperClassName?: string
 *  inputClassName?: string
 * }} props
 */
export default function Input({
  id = '',
  size = 'md',
  label = '',
  caption = '',
  tooltipText = '',
  value = '',
  onChange = () => {},
  error = '',
  disabled = false,
  bypassReadMode = false,
  className = '',
  inputWrapperClassName = '',
  inputClassName = '',
  children = null,
  inputRef = null,
  ...inputHtmlProps
}) {
  const internalId = useId();
  const inputId = id || internalId;

  return (
    <div className={cn(styles.container, className)}>
      <UiKit.Label htmlFor={inputId} text={label} tooltipText={tooltipText}>
        <div className={cn(styles.inputWrapper, inputWrapperClassName)}>
          <input
            ref={inputRef}
            id={inputId}
            value={value}
            onChange={e => onChange(e.target.value, e)}
            disabled={disabled}
            data-size={size}
            data-invalid={!!error}
            data-bypass-read-mode={bypassReadMode}
            className={cn(styles.input, inputClassName)}
            {...inputHtmlProps}
          />
          {children}
        </div>
      </UiKit.Label>
      <UiKit.Error msg={error} hide={disabled} />
      <UiKit.Caption>{caption}</UiKit.Caption>
    </div>
  );
}
